import { render, staticRenderFns } from "./CustomDomain.vue?vue&type=template&id=307ce079&scoped=true"
import script from "./CustomDomain.vue?vue&type=script&lang=js"
export * from "./CustomDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307ce079",
  null
  
)

export default component.exports